import React from "react";

const Think5WhysIsTrusted = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans">
      {/* Header */}
      <header className="bg-gray-900 border-b border-gray-800 px-4 py-4 text-center">
        <h1 className="text-2xl sm:text-3xl font-bold text-yellow-400">🔒 Trusted & Secure Platform</h1>
        <p className="mt-2 text-gray-300 text-sm sm:text-base">
          ISO 9001, ISO 27001, SOC-2 Certified
        </p>
      </header>

      {/* Certifications Section */}
      <section className="mt-6 px-4 sm:px-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-yellow-300 mb-4">Our Certifications</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* ISO 9001 */}
          <div className="bg-gray-800 rounded-lg p-4 shadow hover:shadow-lg transition">
            <h3 className="text-lg font-bold text-yellow-300">ISO 9001</h3>
            <p className="mt-2 text-gray-300 text-sm">
              ISO 9001 certification ensures that our platform adheres to the highest standards of <strong>quality management systems (QMS)</strong>, guaranteeing consistent delivery and customer satisfaction.
            </p>
          </div>

          {/* ISO 27001 */}
          <div className="bg-gray-800 rounded-lg p-4 shadow hover:shadow-lg transition">
            <h3 className="text-lg font-bold text-yellow-300">ISO 27001</h3>
            <p className="mt-2 text-gray-300 text-sm">
              ISO 27001 certification ensures we maintain a robust <strong>information security management system (ISMS)</strong>, protecting user data and platform integrity.
            </p>
          </div>

          {/* SOC-2 */}
          <div className="bg-gray-800 rounded-lg p-4 shadow hover:shadow-lg transition">
            <h3 className="text-lg font-bold text-yellow-300">SOC-2</h3>
            <p className="mt-2 text-gray-300 text-sm">
              SOC-2 certification demonstrates our platform meets strict <strong>security, availability, processing integrity, confidentiality, and privacy</strong> standards, earning trust for all users.
            </p>
          </div>
        </div>
      </section>

      {/* How These Certifications Make Us Trusted */}
      <section className="mt-8 px-4 sm:px-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-yellow-300 mb-4">Why You Can Trust Think5Whys</h2>
        <ul className="list-disc list-inside text-gray-300 space-y-2">
          <li><strong>Consistency & Quality:</strong> ISO 9001 ensures we consistently meet user expectations and deliver quality services.</li>
          <li><strong>Data Security:</strong> ISO 27001 protects sensitive user information and prevents unauthorized access.</li>
          <li><strong>Platform Integrity:</strong> SOC-2 guarantees the system is reliable, secure, and confidential for all transactions and activities.</li>
          <li><strong>Compliance & Transparency:</strong> Our adherence to these standards shows commitment to best practices and regulatory compliance.</li>
        </ul>
      </section>

      {/* Our Process Section */}
      <section className="mt-8 px-4 sm:px-8 pb-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-yellow-300 mb-4">Our Process for Maintaining Trust</h2>
        <ol className="list-decimal list-inside text-gray-300 space-y-2">
          <li>Regular audits of quality and information security management systems.</li>
          <li>Continuous monitoring of security controls and platform performance.</li>
          <li>Employee training programs on best practices for data protection and operational compliance.</li>
          <li>Documented policies and procedures aligned with ISO 9001, ISO 27001, and SOC-2 standards.</li>
          <li>Periodic review and improvement cycles to adapt to emerging security and quality requirements.</li>
        </ol>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 border-t border-gray-800 py-6 text-center text-gray-400 text-sm">
        © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
      </footer>
    </div>
  );
};

export default Think5WhysIsTrusted;
